import StepReceipt from './stepReceipt';

export default StepReceipt;
